export class ApiError extends Error {
  url: string
  code?: string
  constructor(message: string | undefined, url: string | undefined) {
    super(message)
    this.message = message || ''
    this.name = 'ApiError'
    this.url = url || ''
  }
}
export class ApiTimeoutError extends ApiError {
  constructor(url) {
    super('请求超时', url)
    this.name = 'ApiTimeoutError'
  }
}
export class ApiServerError extends ApiError {
  constructor(statusCode: string, url: string | undefined) {
    super(`请求服务器出错`, url)
    this.name = 'ApiServerError'
    this.code = statusCode
  }
}
export class ApiAuthError extends ApiError {
  constructor(url: string | undefined) {
    super('登录已过期', url)
    this.name = 'ApiAuthError'
    this.code = '401'
  }
}
export class ApiRoleError extends ApiError {
  constructor(url: string | undefined) {
    super('当前用户无权访问', url)
    this.name = 'ApiRoleError'
  }
}
export class ApiBusinessError extends ApiError {
  data: any
  constructor(
    message: string,
    code: string,
    url: string | undefined,
    data: any
  ) {
    super(message, url)
    this.name = 'ApiBusinessError'
    this.code = code
    this.data = data
  }
}
